window.OSM = window.OSM ?? {};
/**
 * @type {IMapsProps}
 */
OSM.MapConfigs = OSM.MapConfigs ?? {}

/**
 * See MapCoreConfig.js for working example
 * @type {IMapProps}
 */
OSM.MapConfigs.default = {

}

/**
 * @type {IMapProps}
 */
OSM.MapConfigs.find_a_solicitor = {
    singleMarkerIsPrimaryMarker: false,

    cluster: {

        marker: {
            lngLat: [0, 0],
            iconProps: {
                imagePath: "/app/themes/hailstone/img/layout/solicitor-icon.png",
                scale: 0.71,
                imageIconOrigin: [0, -0.5],
                imageIconInternalOrigin: [0, -0.15]
            }
        }
    }
}